<template>
  <div class="basic_wrap order-page">
    <div class="red_top_bg order-top">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('feng.order') }}
        <span v-if="area">[{{ area }}]</span>
      </div>
      <!-- <button
        v-if="arealist"
        type="button"
        class="top_right area-trigger"
        @click="locationsel = true"
      >
        <van-icon name="location-o" />
      </button> -->
    </div>

    <van-share-sheet
      v-if="arealist"
      v-model="locationsel"
      :title="$t('pro.select')"
      :options="arealist"
      :cancel-text="$t('utils.cancel')"
      @select="onSelect"
    />

    <div class="head-tabs order-tabs">
      <span
        class="tab-item"
        :class="cur==0?'active':''"
        @click="cur=0;page=1;start();"
      >{{ $t('pro.all') }}</span>
      <span
        class="tab-item"
        :class="cur==1?'active':''"
        @click="cur=1;page=1;start();"
      >{{ $t('pro2.succ') }}</span>
      <span
        class="tab-item"
        :class="cur==2?'active':''"
        @click="cur=2;page=1;start();"
      >{{ $t('pro2.fail') }}</span>
      <span
        class="tab-item"
        :class="cur==3?'active':''"
        @click="cur=3;page=1;start();"
      >{{ $t('pro.processing') }}</span>
    </div>

    <div class="tab-content order-content">
      <van-empty
        v-if="empty"
        :description="$t('orders.noOrders')"
      />
      <div
        v-if="!empty"
        class="box"
      >
        <div class="list_wrap">
          <article
            v-for="group in groupedOrders"
            :key="group.key"
            class="mission-card"
          >
            <header
              class="mission-header"
              @click="openOrder(group.rows[0])"
            >
              <img
                class="mission-avatar"
                :src="getOrderImage(group.rows[0])"
                alt=""
                @error="onImageError"
              >
              <div class="mission-title-box">
                <div class="mission-title">
                  {{ getOrderTitle(group.rows[0]) }}
                </div>
                <!-- <div class="mission-number">
                  {{ group.ino }}
                </div> -->
              </div>
              <span
                class="mission-status"
                :class="getGroupStatusClass(group.rows)"
              >
                {{ group.ino }}
                <!-- {{ getGroupStatusText(group.rows) }} -->
              </span>
            </header>

            <div class="cert-row">
              <span class="cert-label">{{ $t('orders.certificationResult') }}:</span>
              <div
                v-if="group.isProcessingResult"
                class="cert-tags notranslate"
              >
                <span class="cert-tag cert-tag-processing">
                  {{ $t('orders.processing') }}
                </span>
              </div>
              <div
                v-else-if="group.labels.length"
                class="cert-tags notranslate"
              >
                <span
                  v-for="label in group.labels"
                  :key="label"
                  class="cert-tag"
                >
                  {{ label }}
                </span>
              </div>
              <span
                v-else
                class="cert-empty"
              >--</span>
            </div>

            <div class="record-list">
              <div
                v-for="item in group.rows"
                :key="item.id"
                class="record-row"
                @click="openOrder(item)"
              >
                <div class="record-main">
                  <div class="record-points">
                    <span>{{ $t('orders.orderPoints') }}:</span>
                    <strong>{{ formatOrderMoney(item.num) }}</strong>
                  </div>
                  <span
                    class="record-state"
                    :class="getOrderStatusClass(item)"
                  >
                    {{ getOrderStatusText(item) }}
                  </span>
                </div>
                <div class="record-time">
                  <!-- <span class="cert-tag">{{ getVoteText(item) }}</span> -->
                  <span>{{ $t('orders.orderTime') }}:</span>
                  <time>{{ item.time }}</time>
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	import Vue from "vue";
	import {
		Empty,Icon,ShareSheet
	} from "vant";
	import Fetch from "../../utils/fetch";
	import defaultAvatar from "../images/31/shop-item.png";

	Vue.use(Empty).use(Icon).use(ShareSheet);
	export default {
		name: "Order",
		data() {
			return {
				lang: this.$i18n.locale || "zh_cn",
				data: null,
				loading:false,
				page:1,
				list:[],
				cur:0,
				area:null,
				arealist:null,
				locationsel: false,
				type:0,
				finished:false,
				empty: false,
				defaultAvatar: defaultAvatar,
			};
		},
		computed: {
			groupedOrders() {
				var groups = [];
				var groupMap = {};
				var list = this.list || [];

				for (var i = 0; i < list.length; i++) {
					var item = list[i];
					var key = String(item.ino || item.id || i);

					if (!groupMap[key]) {
						groupMap[key] = {
							key: key,
							ino: item.ino || "--",
							rows: [],
							labels: [],
						};
						groups.push(groupMap[key]);
					}

					groupMap[key].rows.push(item);
				}

				for (var j = 0; j < groups.length; j++) {
					groups[j].isProcessingResult = !this.hasSettledOrder(groups[j].rows);
					groups[j].labels = groups[j].isProcessingResult ? [] : this.getCertificationLabels(groups[j].rows);
				}

				return groups;
			},
		},
		created() {
			this.$parent.footer("order",true);
		},
		mounted() {
			Fetch('/index/item_search', {
				name: "",
				cate: 0
			}).then(r => {
				var list = r.data.list;
				var result = [];

				for (var i = 0; i < list.length; i ++) {
					var arr = [];
					if(list[i]){
						var it = {
							id:list[i].id,
							name:list[i].jt,
							icon:list[i].img
						};
						arr.push(it);
					}
					i++;

					if(list[i]){
						var it2 = {
							id:list[i].id,
							name:list[i].jt,
							icon:list[i].img
						};
						arr.push(it2);
					}
					i++;
					if(list[i]){
						var it3 = {
							id:list[i].id,
							name:list[i].jt,
							icon:list[i].img
						};
						arr.push(it3);
					}
					i++;
					if(list[i]){
						var it4 = {
							id:list[i].id,
							name:list[i].jt,
							icon:list[i].img
						};
						arr.push(it4);
					}
					i++;
					if(list[i]){
						var it5 = {
							id:list[i].id,
							name:list[i].jt,
							icon:list[i].img
						};
						arr.push(it5);
					}
					result.push(arr);
				}
				this.arealist = result;
			});

			this.start();
		},
		methods: {
			getVoteText(item){
				if (String(item.da) === "1") {
					return this.getCertificationText("da");
				}
				if (String(item.xiao) === "1") {
					return this.getCertificationText("xiao");
				}
				if (String(item.dan) === "1") {
					return this.getCertificationText("dan");
				}
				if (String(item.shuang) === "1") {
					return this.getCertificationText("shuang");
				}
			},
			onSelect(option) {
				this.area = option.name;
				this.type = option.id;
				this.start();
				this.locationsel = false;
			},
			openOrder(item) {
				if (!item || !item.id) {
					return;
				}
				this.$router.push('/orderdetail/' + item.id);
			},
			start() {
				this.loading = true;
				Fetch("/user/item_orders",{
					cur: this.cur,
					type:this.type,
					page:this.page
				}).then((r) => {
					var list = r.data && r.data.list ? r.data.list : [];
					this.data = r.data;
					this.list = list;
					this.empty = list.length === 0;
					this.finished = true;
					this.loading = false;
				}).catch(() => {
					this.loading = false;
				});
			},
			getOrderImage(item) {
				return item && item.item && item.item.img ? item.item.img : this.defaultAvatar;
			},
			onImageError(event) {
				event.target.src = this.defaultAvatar;
			},
			getOrderTitle(item) {
				if (item && item.item && item.item.area) {
					return item.item.area;
				}
				return this.$t('grapHome.luckyMission');
			},
			formatOrderMoney(value) {
				var money = Number(value || 0);
				var mark = typeof this.utils_moneyMark === "function" ? this.utils_moneyMark() : this.$t('utils.moneyMark');

				if (isNaN(money)) {
					money = 0;
				}

				return String(mark || "") + money.toFixed(2);
			},
			getGroupStatusText(rows) {
				var hasPending = rows.some(function(item) {
					return String(item.stat) === "0";
				});

				return hasPending ? this.$t('orders.pending') : this.$t('orders.completed');
			},
			getGroupStatusClass(rows) {
				var hasPending = rows.some(function(item) {
					return String(item.stat) === "0";
				});

				return hasPending ? "is-pending" : "is-completed";
			},
			getOrderStatusText(item) {
				if (String(item.stat) === "0") {
					return this.$t('orders.pending');
				}
				if (Number(item.zhong) > 0) {
					return this.$t('orders.profit');
				}
				return this.$t('orders.loss');
			},
			getOrderStatusClass(item) {
				if (String(item.stat) === "0") {
					return "is-pending";
				}
				if (Number(item.zhong) > 0) {
					return "is-profit";
				}
				return "is-loss";
			},
			hasSettledOrder(rows) {
				return rows.some(function(item) {
					return String(item.stat) === "1";
				});
			},
			getCertificationLabels(rows) {
				var settled = null;
				var result = [];

				for (var i = 0; i < rows.length; i++) {
					if (String(rows[i].stat) === "1") {
						settled = rows[i];
						break;
					}
				}

				if (settled) {
					result = this.getSettledLabels(settled);
				}

				return this.uniqueLabels(result);
			},
			getSettledLabels(item) {
				var labels = [];

				if (String(item.ida) === "0") {
					labels.push(this.getCertificationText("da"));
				}
				if (String(item.ida) === "1") {
					labels.push(this.getCertificationText("xiao"));
				}
				if (String(item.idan) === "0") {
					labels.push(this.getCertificationText("dan"));
				}
				if (String(item.idan) === "1") {
					labels.push(this.getCertificationText("shuang"));
				}

				return labels;
			},
			getSelectedLabels(item) {
				var labels = [];

				if (String(item.da) === "1") {
					labels.push(this.getCertificationText("da"));
				}
				if (String(item.xiao) === "1") {
					labels.push(this.getCertificationText("xiao"));
				}
				if (String(item.dan) === "1") {
					labels.push(this.getCertificationText("dan"));
				}
				if (String(item.shuang) === "1") {
					labels.push(this.getCertificationText("shuang"));
				}

				return labels;
			},
			getCertificationText(type) {
				var map = {
					da: "buyMission.rose",
					xiao: "buyMission.lily",
					dan: "buyMission.fireworks",
					shuang: "buyMission.balloon",
				};

				return map[type] ? this.$t(map[type]) : "";
			},
			uniqueLabels(labels) {
				var result = [];

				for (var i = 0; i < labels.length; i++) {
					if (labels[i] && result.indexOf(labels[i]) === -1) {
						result.push(labels[i]);
					}
				}

				return result;
			},
		},
	};
</script>

<style lang="less" scoped>
.order-page {
	min-height: 100vh;
	background: #fff;
	color: #16223a;
	padding-bottom: 80px;
	box-sizing: border-box;
}

.order-top {
	background: #fff;
	color: #16223a;
	border-bottom: 1px solid rgba(240, 242, 245, 1);
	box-sizing: border-box;

	.back_left {
		opacity: 0.88;
	}

	.big_tit {
		max-width: 72%;
		color: #16223a;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		word-break: normal;
	}
}

.area-trigger {
	top: 9px;
	right: 15px;
	width: 30px;
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	color: #ff5d7a;
	font-size: 14px;
	background: rgba(255, 93, 122, 0.12);
}

.order-tabs {
	width: auto;
	height: 42px;
	margin: 10px 16px 12px;
	padding: 5px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-radius: 13px;
	border: 1px solid rgba(255, 93, 122, 0.18);
	background: #fff0f4;
	color: #6d7688;

	.tab-item {
		flex: 1;
		height: 30px;
		line-height: 30px;
		margin: 0;
		border-radius: 10px;
		font-size: 12px;
		color: #6d7688;
		text-align: center;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		word-break: normal;
	}

	.tab-item:after {
		display: none;
	}

	.tab-item + .tab-item {
		margin-left: 4px;
	}

	.tab-item.active {
		font-size: 12px;
		font-weight: 600;
		color: #fff;
		background: linear-gradient(180deg, #ff7791 0%, #ff5574 100%);
		box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.18);
	}
}

.order-content {
	padding: 0 0 18px;
}

.box {
	padding-bottom: 0;
}

.list_wrap {
	margin: 0;
	padding: 0 16px 16px;
}

.mission-card {
	width: 100%;
	margin-bottom: 14px;
	overflow: hidden;
	border-radius: 14px;
	border: 1px solid rgba(255, 93, 122, 0.16);
	background: #fff;
	box-shadow: 0 12px 22px rgba(22, 34, 58, 0.08);
	box-sizing: border-box;
}

.mission-header {
	min-height: 76px;
	padding: 16px 23px;
	display: flex;
	align-items: center;
	background: #fff6f8;
	border-bottom: 1px solid rgba(240, 242, 245, 1);
	box-sizing: border-box;
}

.mission-avatar {
	width: 45px;
	height: 45px;
	flex: 0 0 45px;
	object-fit: cover;
	border-radius: 8px;
	background: #fff0f4;
}

.mission-title-box {
	min-width: 0;
	flex: 1;
	margin-left: 16px;
	display: flex;
	align-items: baseline;
	white-space: nowrap;
	word-break: normal;
}

.mission-title {
	max-width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	color: #ff5d7a;
	font-size: 14px;
	font-weight: 700;
	line-height: 20px;
	word-break: normal;
}

.mission-number {
	min-width: 0;
	margin-left: 10px;
	overflow: hidden;
	text-overflow: ellipsis;
	color: #6d7688;
	font-size: 14px;
	line-height: 18px;
	word-break: normal;
}

.mission-status {
	flex: 0 0 auto;
	margin-left: 8px;
	padding: 5px 13px;
	border-radius: 14px;
	font-size: 14px;
	font-weight: 700;
	line-height: 16px;
	text-align: center;
	white-space: nowrap;
	word-break: normal;
	box-sizing: border-box;
}

.mission-status.is-completed {
	color: #24f18c;
	background: #639077;
}

.mission-status.is-pending {
	color: #ff5d7a;
	background: #ffe7ed;
}

.cert-row {
	min-height: 68px;
	padding: 14px 23px;
	display: flex;
	align-items: center;
	border-bottom: 1px dashed rgba(240, 242, 245, 1);
	box-sizing: border-box;
}

.cert-label {
	flex: 0 0 auto;
	margin-right: 14px;
	color: #46546c;
	font-size: 14px;
	line-height: 20px;
	white-space: nowrap;
	word-break: normal;
}

.cert-tags {
	min-width: 0;
	display: flex;
	flex-wrap: wrap;
	gap: 8px 12px;
}

.cert-tag {
	min-width: 60px;
	height: 30px;
	padding: 0 16px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	border-radius: 8px;
	border: 1px solid rgba(255, 93, 122, 0.42);
	background: linear-gradient(180deg, #ff7791 0%, #ff5574 100%);
	color: #fff;
	font-size: 12px;
	font-weight: 700;
	line-height: 30px;
	white-space: nowrap;
	word-break: normal;
	box-sizing: border-box;
}

.cert-tag-processing {
	min-width: 0;
	height: 28px;
	padding: 0 12px;
	border-radius: 14px;
	border-color: rgba(255, 93, 122, 0.26);
	background: rgba(255, 93, 122, 0.12);
	color: #ff5d7a;
	font-size: 12px;
	line-height: 28px;
}

.cert-empty {
	color: #6d7688;
	font-size: 14px;
}

.record-list {
	padding: 0 23px 3px;
}

.record-row {
	padding: 19px 0 16px;
	border-bottom: 1px solid rgba(240, 242, 245, 1);
}

.record-row:last-child {
	border-bottom: 0;
}

.record-main,
.record-time {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.record-points {
	min-width: 0;
	display: flex;
	align-items: baseline;
	color: #16223a;
	font-size: 14px;
	line-height: 20px;
	white-space: nowrap;
	word-break: normal;
}

.record-points span {
	margin-right: 10px;
	font-weight: 500;
}

.record-points strong {
	overflow: hidden;
	text-overflow: ellipsis;
	color: #ff5d7a;
	font-size: 14px;
	font-weight: 700;
	word-break: normal;
}

.record-state {
	flex: 0 0 auto;
	margin-left: 12px;
	font-size: 14px;
	font-weight: 700;
	line-height: 20px;
	white-space: nowrap;
	word-break: normal;
}

.record-state.is-profit {
	color: #ff5d7a;
}

.record-state.is-loss,
.record-state.is-pending {
	color: #566174;
}

.record-time {
	margin-top: 8px;
	color: #6d7688;
	font-size: 12px;
	line-height: 20px;
	word-break: normal;
}

.record-time span,
.record-time time {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	word-break: normal;
}

.record-time time {
	margin-left: 12px;
	text-align: right;
}

/deep/ .van-empty {
	padding-top: 72px;
}

/deep/ .van-empty__description {
	color: #9aa1aa;
	font-size: 12px;
}

@media screen and (max-width: 374px) {
	.order-tabs {
		margin-right: 12px;
		margin-left: 12px;
	}

	.list_wrap {
		padding-right: 12px;
		padding-left: 12px;
	}

	.mission-header,
	.cert-row,
	.record-list {
		padding-right: 14px;
		padding-left: 14px;
	}

	.mission-header {
		min-height: 70px;
	}

	.mission-title-box {
		margin-left: 12px;
	}

	.mission-avatar {
		width: 40px;
		height: 40px;
		flex-basis: 40px;
	}

	.mission-title {
		font-size: 14px;
	}

	.mission-status {
		padding: 4px 10px;
		line-height: 16px;
	}

	.mission-number,
	.mission-status,
	.cert-label,
	.cert-tag,
	.record-state,
	.record-time {
		font-size: 12px;
	}

	.cert-tag {
		min-width: 56px;
		height: 28px;
		padding: 0 10px;
		line-height: 28px;
	}

	.record-points,
	.record-points strong {
		font-size: 14px;
	}
}
</style>
